// extracted by mini-css-extract-plugin
export var card = "_m6-0";
export var content = "_m6-2";
export var details = "_m6-3";
export var icon = "_m6-1";
export var iconBlue = "_m6-5";
export var iconBrand = "_m6-4";
export var iconGrayBlue = "_m6-6";
export var iconGreen = "_m6-7";
export var iconIndigo = "_m6-8";
export var iconOrange = "_m6-9";
export var iconPurple = "_m6-a";
export var iconRed = "_m6-b";
export var iconWarning = "_m6-c";